module.exports = __webpack_public_path__ + "public/img/qiaqia_qr.f30f6ce6.jpg";